export const REHYDRATE_STATE = "REHYDRATE_STATE";
export const PERSIST_STATE = "PERSIST_STATE";
export const CLEAR_STATE = "CLEAR_STATE";
